// /frontend/src/services/wishlistService.js
import apiClient from '../utils/apiClient';

const API_URL = `${process.env.REACT_APP_API_URL}/wishlist`;

export const wishlistService = {
  // Get user's wishlist
  getWishlist: async () => {
    try {
      const response = await apiClient.get(API_URL);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching wishlist:", error);
      throw error;
    }
  },

  // Add product to wishlist
  addToWishlist: async (productId) => {
    try {
      const response = await apiClient.post(`${API_URL}/add`, { productId });
      return response.data;
    } catch (error) {
      console.error("Error adding to wishlist:", error);
      throw error;
    }
  },

  // Remove product from wishlist
  removeFromWishlist: async (productId) => {
    try {
      const response = await apiClient.delete(`${API_URL}/remove/${productId}`);
      return response.data;
    } catch (error) {
      console.error("Error removing from wishlist:", error);
      throw error;
    }
  },

  // Check if product is in wishlist
  isInWishlist: async (productId) => {
    try {
      const response = await apiClient.get(`${API_URL}/check/${productId}`);
      return response.data.data;
    } catch (error) {
      console.error("Error checking wishlist status:", error);
      throw error;
    }
  }
};